$(document).ready(function () {
    $('a[role="navigation"]').each(function () {
        if (location.href === $(this).attr('href')) {
            $(this).addClass('active');


            let submenu = $(this).parents('.collapse');
            if (submenu) {
                submenu.addClass('show');
                $(this).parent('li').addClass('text-primary');
            }
        }
    });
});
